import { AsyncStorage } from './device';
export default AsyncStorage;
